import { observable, action, computed } from 'mobx';
import { mapValues } from 'lodash';
import { Report } from 'api';
import routerStore from './RouterStore';

class ReportStore {
  @observable report;

  @observable fetchState;

  anketId;

  @computed
  get formData() {
    return mapValues(this.report, 'value');
  }

  @action.bound
  async getReport(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Report.getReport(anketId);
      this.report = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }

  @action.bound
  async updateReport(anketId, data) {
    this.fetchState = 'pending';

    try {
      await Report.updateReport(anketId, data);
      const response = await Report.getReport(anketId);
      this.report = response.data;
      routerStore.goBack();
      this.fetchState = 'fulfilled';
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const reportStore = new ReportStore();

export default reportStore;
